import { PropertyStripLayout } from '../../../canvas/properties/PropertyStripLayout';
import { CalendarFrameAddon } from './CalendarFrameAddon';
import { FrameAddonMonthYearWidget } from './FrameAddonMonthYearWidget';

export const CalendarFrameAddonPropertyLayout = PropertyStripLayout<CalendarFrameAddon>((d, s, o, w, a) => {

    return [
        // From
        w.createColorSelector({
            autoSelect: true,
            groups: true,
            value: a.get('color'),
            text: 'Calendar Color',
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('color'));
                    a.set('color', this.value!);
                });
            }
        }),
        // Month
        w.createPopout({
            text: 'Date',
            image: 'deqo://icons/i8/calendar',
            value: a.get('from') ?? new Date(),
            ui: FrameAddonMonthYearWidget,
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('from'));
                    a.set('from', this.value! ?? new Date());
                });
            }
        }),
        // Settings
        // w.createPopout({
        //     text: 'Headers',
        //     image: 'deqo://icons/i8/table-settings',
        //     value: {
        //         headers: a.get('headers'),
        //         weekends: a.get('weekends'),
        //     },
        //     ui: CalendarFrameAddonHeadersWidget,
        //     onSelect() {
        //         o.update(u => {
        //             u.rolling(a.keyFor('headers', 'weekends'));
        //             a.set('headers', this.value!.headers);
        //             a.set('weekends', this.value!.weekends);
        //         });
        //     }
        // }),
    ];
});
